import { TextInputLabelled } from 'components/shared/text-input/text-input-labelled';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { TextFieldMetadata } from 'models/forms/fields';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

export function TextField({ id, translationKey, isReadOnly }: TextFieldMetadata) {
  const [value, setFormData] = useFormFieldData<Nullable<string>>(id);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  const { translateLabel } = useTranslateForm();
  const label = translateLabel(translationKey ?? id);

  return (
    <ErrorWrapper error={fieldError}>
      <TextInputLabelled
        id={id}
        label={label}
        value={value}
        onValueChanged={setFormData}
        isReadOnly={isReadOnly}
        isInvalid={fieldError?.severity === 'Error'}
        isHighlighted={fieldError?.severity === 'Warning'}
        type="text"
      />
    </ErrorWrapper>
  );
}
